export const STREAM_MODE = {
  TRANSCODE: 'transcode',
  NORMAL: 'normal',
};

export const timeToSeconds = (timeStr) => {
  const parts = timeStr.split(':');
  return (
    parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2])
  );
};

export const secondsToTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const genDownloadKeyLocal = (serial, fromTime, toTime) => {
  return `playback-local-${serial}|${fromTime}-${toTime}`;
};
